<template>
  <div class="packages-view">
        <div class="select-tabs-con">
            <app-header @on-click="goBack" class="packages-head"/>
            <van-tabs 
                :class="'van-tabs-con'" 
                :active="activeTab" 
                swipe-threshold="3" 
                swipeable 
                animated 
                color="#4361EE" 
                title-active-color="#4361ee" 
                title-inactive-color="#000" 
                line-width="10%" 
                line-height="0.2em"
                @change="handleTabsChange"
            >
                <van-tab :title="$t('select_package.title')" :name="'selected'"></van-tab>
                <van-tab :title="$t('select_package.allPackage')" :name="'allPackage'"></van-tab>
            </van-tabs>
        </div>
        <div class="package-list-con">
            <select-packageVue 
                v-if="activeTab === 'selected'"
                :allPackageList="allPackageList"
                :allTagList="allTagList"
                :regionList="regionList"
            ></select-packageVue>
            <new-packageListVue 
                v-if="activeTab === 'allPackage'"
                :allPackageList="allPackageList"
                :allTagList="allTagList"
                :regionList="regionList"
                :tagList="tagList"
            ></new-packageListVue>
        </div>
  </div>
</template>

<script>
import { Tab, Tabs } from 'vant';
import checkProjectConfig from '@/lib/checkProjectConfig';
import NewPackageListVue from './newPackageList.vue';
import SelectPackageVue from './SelectPackage.vue';
export default {
    name: "Packages",
    data() {
        return {
            activeTab: 'selected',
            tagList:[],
            allTagList:[],
            allPackageList: [],
            regionList: [],
        }
    },
    components: {
        vanTabs: Tabs,
        vanTab: Tab,
        NewPackageListVue,
        SelectPackageVue
    },
    mounted() {
        // this.setup();
    },
    activated() {
        this.setup();
    },
    beforeRouteEnter: (to, from, next) => {
        // 如果是从Home页进入，默认选中selected标签页
        next(vm => {
          if(from.name === 'Home'){
            vm.activeTab = 'selected';
          }
      });
    },
    methods: {
        async setup() {
            let placeCode = JSON.parse( sessionStorage.getItem('urlData') || '{}').placeCode  ||
                            JSON.parse( sessionStorage.getItem('ProjectConfigDetailData') || '{}').placeCode;
            if(placeCode) {
                this.placeCode = placeCode;
            }
            let Module_Coupon = checkProjectConfig.setAppThat(this).checkValue("Module_Coupon",false);
            if(Module_Coupon) {
                try {
                    await this.getCouponsList();
                } catch (error) {
                    console.log(error);
                }
            }
            this.getPackageTagList(() => {
                this.getHotRegion(() => {
                    // if(this.allTagList && this.allTagList.length === 1 && this.allTagList[0].tagKey === 'ROAMING'){
                    //     this.getRoamingPackageList();
                    // } else {
                        this.getLocalPackageList();
                    // }
                });
            });
        },
        goBack() {
            this.$router.go(-1);
        }, 
        // 切换tab
        handleTabsChange(name,title) {
            this.activeTab = name;
        },
        // 获取优惠券列表
        async getCouponsList() {
                let sessionStorageUrlData = JSON.parse(sessionStorage.urlData || '{}') || {};
                let res  = await this.$http
                .post({
                    url: "/bss/app/promotion/queryPromotionInst",
                    data: {
                        currentPage: 1,
                        perPageCount: 1000,
                        loginCustomerId: sessionStorageUrlData.loginCustomerId,
                        status:'AVAILABLE'
                    },
                })
                let data_CouponList = (res?.data?.dataList || []).map(item => {
                    return {
                        goodsList: item.goodsList,
                        promotionMode: item.promotionMode,
                        promotionCode: item.promotionCode,
                        fullCut: item.fullCut,
                        quota: item.quota,
                    }
                })
                sessionStorage.setItem('data-couponList', JSON.stringify(data_CouponList));
        },
        // 查询套餐标签
        getPackageTagList(success) {
            let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
            if(!urlData.loginCustomerId) return;
            this.$http.post({
                url: 'bss/app/noauth/QueryOfferTag',
                data: {
                    ignoreOfferTagFlag: 1,
                    offerTagFlag:0,
                    offerTagMethod:1,
                }
            })
            .then((res) => {
                if(res.data && res.data.length){
                    this.allTagList = res.data;
                    res.data.forEach((element) => {
                        if (element.tagKey === "LOCAL" && element.tagValueList) {
                            this.tagList = element.tagValueList.map((item) => {
                                return {
                                    ...item,
                                    // 获取element.extendValueMap的key
                                    extendValue: Object.keys(item.extendValueMap)[0] || "",
                                    key: Object.keys(item.extendValueMap)[0] || "",
                                    value: item.tagValueName
                                };
                            });
                        }
                    });
                    success && success();
                } else {
                    // this.getLocalPackageList(); // 如果没有标签数据，则直接查询本地流量套餐
                }
            })
            .catch((err) => {
                console.log(err);
            });
        },
        // 查询热门大洲套餐
        async getHotRegion(success) {
            let typeCode ;
            let typeCode_mvnoCode = JSON.parse(sessionStorage.getItem('urlData') || '{}').mvnoCode;

            if(typeCode_mvnoCode){
                typeCode =  `HOTREGION_${typeCode_mvnoCode.toUpperCase()}`;
                try {
                    let res = await this.$http.post({
                        url: '/bss/app/noauth/dictionary/QueryDictionaryValueListInfo',
                        data: {                      
                            type: typeCode, 
                        }
                    })
                    // Africa - UN60 、Oceania - UN29、 Asia - UN50、European - UN52、SouthAmerica - UN57、 NorthAmerica - UN57
                    this.regionList = res.data || [];
                    success && success();
                } catch (error) {
                    success && success();
                }
            }
        },
        // 查询套餐列表
        getLocalPackageList(){
            let urlData = JSON.parse(sessionStorage.urlData) || {};
            let channelType = this.$APP_CONFIG.request.channelType,
                mcc = this.placeCode;
            let tagKeyList = this.tagList.map(item => item.extendValue);
            let extendAttrs = this.regionList.map(item => item.key);
            this.$http.post({
                url: '/bss/app/noauth/QueryOfferList',
                data: {                        
                    channelType,
                    // mcc,
                    queryLimitFlag: true,
                    queryPromotionFlag: true,
                    sortFlag: 1,
                    showFlowFlag:1,
                    // areaFlag: 'LOCAL', // 保留原来没有extendValueMap的逻辑，查询本地流量套餐
                    params: {
                        queryVipDayFlag: true
                    },
                    buyTerminalType:urlData.terminalType,
                    goodsExtendAttrs:["detailRemark","hideFlowSize",...tagKeyList,...extendAttrs], // detailRemark 获取扩展属性
                    perPageCount: 2000,
                }
            }).then(res => {            
                this.allPackageList = res.data.dataList || [];
            }).catch(err => {
                this.$toast(err);
                console.log(err);
                
            });
        },
    }
}
</script>

<style lang="less" scoped>
.packages-view {
    ::v-deep {
        .header {
            font-weight: 600;
            height: 44px;         
            .title {
                font-size: 15px;
            }
        }
    }
    height: 100vh;
    height: 100dvh;
    .select-tabs-con {
        display: flex;
        .packages-head {
            width: 38px;
            height: 44px;
            ::v-deep {
                .left {
                    padding: 0;
                    right: 0;
                    display: flex;
                    justify-content: center;
                }
            }
        }
        .van-tabs-con {
            font-weight: 600;
            flex: 1;
        }
        ::v-deep {
            .van-tab--active {
                .van-tab__text {
                    font-weight: 600;
                }
            }
        }
    }
    .package-list-con {
        height: calc(100dvh - 44px);
        background-color: #f2f2f2;
    }
}
</style>